import revive_payload_client_4sVQNw7RlN from "D:/Out/MedCAT/MedCAT.Cms/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "D:/Out/MedCAT/MedCAT.Cms/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "D:/Out/MedCAT/MedCAT.Cms/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import theme_init_7vFcvaOCOT from "D:/Out/MedCAT/MedCAT.Cms/plugins/theme-init.ts";
import payload_client_yVLowv6hDl from "D:/Out/MedCAT/MedCAT.Cms/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "D:/Out/MedCAT/MedCAT.Cms/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "D:/Out/MedCAT/MedCAT.Cms/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "D:/Out/MedCAT/MedCAT.Cms/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "D:/Out/MedCAT/MedCAT.Cms/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "D:/Out/MedCAT/MedCAT.Cms/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "D:/Out/MedCAT/MedCAT.Cms/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "D:/Out/MedCAT/MedCAT.Cms/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "D:/Out/MedCAT/MedCAT.Cms/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import directives_8CcCirWtnE from "D:/Out/MedCAT/MedCAT.Cms/plugins/directives.ts";
import helpers_mgWmzbOuLB from "D:/Out/MedCAT/MedCAT.Cms/plugins/helpers.ts";
import stringee_XrJKojbxK0 from "D:/Out/MedCAT/MedCAT.Cms/plugins/stringee.ts";
import swiper_eteSCvuYkd from "D:/Out/MedCAT/MedCAT.Cms/plugins/swiper.ts";
import vue3_toastify_OGYNDsiW9E from "D:/Out/MedCAT/MedCAT.Cms/plugins/vue3-toastify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  theme_init_7vFcvaOCOT,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  directives_8CcCirWtnE,
  helpers_mgWmzbOuLB,
  stringee_XrJKojbxK0,
  swiper_eteSCvuYkd,
  vue3_toastify_OGYNDsiW9E
]